import { Directive, HostBinding } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[campusPrimary],[primary]',
})
export class PrimaryDirective {
  @HostBinding('class.ui-button--primary')
  get isPrimaryClass() {
    return true;
  }
}
